let oneMb = 1024 * 1024;
let maxFileSizeInMb = 30;
export const FileUploadConfig = {
  oneMb,
  maxFileSizeInMb,
  maxFileSize: maxFileSizeInMb * oneMb,
  allowedFileTypes: ['image', 'doc', 'xls', 'ppt', 'pdf'],
};
